import { trigger, style, transition, animate, state } from '@angular/animations';

const children = trigger('children', [
  state(
    'collapsed',
    style({
      height: '0',
    })
  ),
  state(
    'expanded',
    style({
      height: '*',
    })
  ),
  state(
    'hidden',
    style({
      display: 'none',
    })
  ),
  state(
    'visible',
    style({
      display: 'block',
    })
  ),
  transition('collapsed <=> expanded', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
]);

export { children };
